import { useRevalidator } from 'react-router';
import { AvailabilityUnavailableNotice } from '~/ui/availability-unavailable';
import { BookingPanelCard } from './booking-panel-card';

/**
 * The tablet+ booking panel when the experience's dates or slots could not be
 * checked. Stands in for either mode's panel: with no dates in hand there is
 * nothing mode-specific to show.
 */
export function BookingPanelUnavailable({
  canProceedToCheckout,
}: {
  canProceedToCheckout: boolean;
}) {
  const revalidator = useRevalidator();
  return (
    <BookingPanelCard canProceedToCheckout={canProceedToCheckout}>
      <AvailabilityUnavailableNotice
        onRetry={() => void revalidator.revalidate()}
        retrying={revalidator.state === 'loading'}
      />
    </BookingPanelCard>
  );
}
